// tslint:disable: no-invalid-template-strings
import { ActionType, createAction } from 'typesafe-actions';
import { IListObjectStore } from '../../_common/type';
import {
    ECRBRecordCode,
    TCRBBackendRecord,
    TCRBHistoryFilters,
} from './@types';

enum ECRBConstants {
    FEATURE = '@crb',
    // API = '/crb',
    API = '/api/marpol/all',
}

enum ECRBActions {
    HISTORY_LOAD = '@crb/:history-load',
    HISTORY_SET = '@crb/${history}/set',

    GOTO_DASHBOARD = '@crb/-->dashboard',
    GOTO_OPERATION_DASHBOARD = '@crb/-->operation-dashboard',
    GOTO_SELECTED_OPERATION = '@crb/-->selected-operation',
    GOTO_HISTORY = '@crb/-->history',

    SET_FILTER = '@crb/:set-filter',
}

const crbActions = {
    commands: {
        historyLoad: createAction(
            ECRBActions.HISTORY_LOAD,
            (providedFilters: TCRBHistoryFilters) => ({ providedFilters })
        )(),
    },
    document: {
        historySet: createAction(
            ECRBActions.HISTORY_SET,
            (history: IListObjectStore<TCRBBackendRecord>) => ({ history })
        )(),
        setFilter: createAction(ECRBActions.SET_FILTER, (filter: any) => ({
            filter,
        }))(),
    },
    routes: {
        gotoDashboard: createAction(ECRBActions.GOTO_DASHBOARD)(),
        gotoOperationDashboard: createAction(
            ECRBActions.GOTO_OPERATION_DASHBOARD
        )(),
        gotoSelectedOperation: createAction(
            ECRBActions.GOTO_SELECTED_OPERATION,
            (operationCode: ECRBRecordCode) => ({ operationCode })
        )(),
        gotoHistory: createAction(ECRBActions.GOTO_HISTORY)(),
    },
    events: {},
};

export type TCRBActions = ActionType<typeof crbActions>;
export default crbActions;
export { ECRBConstants, ECRBActions };
